import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import Svg from 'components/util/Svg'
import paginator from 'services/paginator/paginator'
import PaginatorControls from 'components/util/PaginatorControls'
import styles from './_myCoursesPage.css'
import selectStyles from 'components/forms/SelectField/_selectField.css'
import * as courseActions from 'services/courses/actions'
import * as user from 'services/user/selectors'
import * as activityTypes from 'services/activityTypes/selectors'
import * as activityTypeActions from 'services/activityTypes/actions'
import MyRoutesHeader from './MyRoutesHeader'
import MyCourseResults from './MyCourseResults'

const paginatorOptions = {
  name: 'myCoursesPage',
  perPage: 10,
  maxPageButtons: 3,
}

const mapStateToProps = (state) => ({
  userId: user.selectUserId(state),
  popularActivityTypes: activityTypes.selectPopularActivityTypes(state),
})

const messages = defineMessages({
  coursesDone: {
    id: 'courses.ihavedone',
    defaultMessage: 'Courses I have done',
  },
  coursesCreated: {
    id: 'courses.ihavecreated',
    defaultMessage: 'Courses I have created',
  },
})

const mapDispatchToActions = { ...courseActions, ...activityTypeActions }

export class MyCoursesPage extends Component {
  static propTypes = {
    userId: PropTypes.number,
    getUserCoursesPage: PropTypes.func,
    paginator: PropTypes.object,
    fetchActivityTypes: PropTypes.func,
    popularActivityTypes: PropTypes.array,
    intl: PropTypes.object,
  }

  state = {
    activityType: 16,
    doneOrCreated: 'done',
  }

  componentDidMount () {
    this.props.fetchActivityTypes()
  }

  loadPaginatorPage = ({ limit, offset }) => {
    return this.props.getUserCoursesPage({
      limit,
      offset,
      userId: this.props.userId,
      activityTypeId: this.state.activityType,
      mine: this.state.doneOrCreated === 'created',
    })
  }

  handleActivityTypeChange = (e) => {
    this.setState({
      activityType: parseInt(e.target.value, 10),
    }, () => this.props.paginator.loadPage())
  }

  handleDoneCreatedChange = (e) => {
    this.setState({
      doneOrCreated: e.target.value,
    }, () => this.props.paginator.loadPage())
  }

  render () {
    const {
      paginator: {
        loading,
        results,
      },
      popularActivityTypes,
      intl,
    } = this.props

    const {
      activityType,
      doneOrCreated,
    } = this.state

    return (
      <div className={styles.myCoursesContainer}>
        <MyRoutesHeader />
        <h3 className={styles.myCoursesTitle}>
          <FormattedMessage
            id='mycourses.title'
            defaultMessage='My Courses' />
        </h3>
        <div className={styles.searchContainer}>
          <Row>
            <Col xs={12} smOffset={6} sm={3}>
              <div className={classnames(selectStyles.inputContainer, styles.activitySelect)}>
                <select value={activityType} className={selectStyles.input} onChange={this.handleActivityTypeChange}>
                  {popularActivityTypes.map((activity, i) => {
                    return <option key={i} value={activity._links.self[0].id}>{activity.name}</option>
                  })}
                </select>
                <Svg name='select_down' className={selectStyles.arrow} />
              </div>
            </Col>
            <Col xs={12} sm={3}>
              <div className={selectStyles.inputContainer}>
                <select value={doneOrCreated} className={selectStyles.input} onChange={this.handleDoneCreatedChange}>
                  <option value='done'>
                    {intl.formatMessage(messages.coursesDone)}
                  </option>
                  <option value='created'>
                    {intl.formatMessage(messages.coursesCreated)}
                  </option>
                </select>
                <Svg name='select_down' className={selectStyles.arrow} />
              </div>
            </Col>
          </Row>
        </div>
        <MyCourseResults
          courses={results}
          loading={loading} />
        <PaginatorControls {...this.props.paginator} />
      </div>
    )
  }
}

export const PaginatorPage = paginator(paginatorOptions)(MyCoursesPage)
export const IntlPage = injectIntl(PaginatorPage)
export default connect(mapStateToProps, mapDispatchToActions)(IntlPage)
